import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Country } from "@models";
import { PaymentAccount } from "@models/payment_account";
import { BankAccountDetails } from "@models/bank_account_details";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";

@Component({
	selector: "confirm-mandate-modal",
	templateUrl: "./confirm-mandate-modal.component.html",
	styleUrls: ["./confirm-mandate-modal.component.scss"],
	standalone: false
})
export class ConfirmMandateModalComponent {
	private _account: PaymentAccount = null;
	private _supportUrl: string = "";

	@Input("bankAccount") public set bankAccount(account: PaymentAccount) {
		this._account = account;
	}
	@Input() public readonly: boolean = true;
	@Input() public showBackButton: boolean = true;
	@Output() public buttonClick: EventEmitter<string> = new EventEmitter();

	public constructor(
		private masterdataService: MasterdataService,
		private translationService: TranslationService
	) {
		this._supportUrl = this.translationService.getHdLink("/requests/new?revoke=1");
	}

	public get account(): PaymentAccount {
		return this._account;
	}

	public getBankAccountDetails(): BankAccountDetails {
		if (!this.account) {
			return null;
		}
		return this.account.bankAccountDetails;
	}

	public getCountry(): Country {
		return this.masterdataService.getCountryById(this.account.getCountryId());
	}

	public onButtonClick(button: string): void {
		this.buttonClick.emit(button);
	}

	public getSupportUrl(): string {
		return this._supportUrl;
	}
}
